import { Component, Injector, OnInit } from '@angular/core';
import { BaseEntityComponent, BaseEntityConfig, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ROLE_AGENTE_ENVIO } from 'src/app/constantes/permissao.constants';
import { NovaAmortizacaoAntecipada } from 'src/app/model/operacao-credito-livre.model';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { RemoverAlertasService } from 'src/app/shared/services/remover-alertas.service';
import { AmortizacaoAntecipadaService } from '../amortizacao-antecipada.service';

@Component({
    selector: 'app-amortizacao-detalhe',
    templateUrl: './amortizacao-detalhe.component.html',
    styleUrls: ['./amortizacao-detalhe.component.css'],
    standalone: false
})
export class AmortizacaoDetalheComponent extends BaseEntityComponent<NovaAmortizacaoAntecipada>
    implements OnInit {

    public ocorrencias: OcorrenciaValidacaoVO[] = [];
    public carregada = false;
    public estadoInicial: NovaAmortizacaoAntecipada;
    public mostrarAmortizacoesAntecipadas: boolean = true;
    public temAmortizacoesAntecipadas: boolean = false;

    constructor(
        protected injector: Injector,
        private amortizacaoAntecipadaService: AmortizacaoAntecipadaService,
        private permissaoService: PermissaoService,
        private removerAlertasService: RemoverAlertasService
    ) {
        super(amortizacaoAntecipadaService);
        this.estadoInicial = <NovaAmortizacaoAntecipada>this.router.getCurrentNavigation().extras.state;
    }

    ngOnInit(): void {
        this.permissaoService
            .getPermissoesUsuarioAutenticado()
            .subscribe ((resp: any) => {
                console.debug(this.estadoInicial);
                this.estadoInicial.fluxoParcelasAposAmortizacao.forEach(a => a.valor = this.ajustaCasasDecimais(a.valor));
                this.temAmortizacoesAntecipadas = this.estadoInicial.fluxoParcelasAposAmortizacao.some(amort => amort.antecipada);
                this.estadoInicial.valorTotalAmortizacaoAntecipada = 0;
                this.model = <NovaAmortizacaoAntecipada>{...this.estadoInicial};
                this.model.fluxoParcelasAposAmortizacao = this.estadoInicial.fluxoParcelasAposAmortizacao.slice();

                console.log(`amortizações atuais da operação ${this.model.id} recuperadas`);

                // rota para voltar à tela de garantia 
                this.setConfig(new BaseEntityConfig(`operacoes/${this.model.id}`));
                this.carregada = true;
            });
    }

    salvar() {
        super.antesDeSalvar();
        this.ocorrencias = [];
        this.removerAlertasService.removerTodos();
        let clone: NovaAmortizacaoAntecipada = <NovaAmortizacaoAntecipada>{...this.model};
        clone.fluxoParcelasAposAmortizacao = clone.fluxoParcelasAposAmortizacao.filter(amort => !amort.antecipada);
        this.amortizacaoAntecipadaService.enviarAmortizacoes(clone, false).subscribe(resp => {
            this.messageService.addMessage({
                title: 'Sucesso',
                type: 'CRUD_OPERATION',
                level: messageLevel.SUCCESS,
                message: 'Amortização antecipada enviada com sucesso.'
            });
            this.voltarParaLista()
            this.aposSalvar();
        }, error => {
            console.log(error);
            this.ocorrencias = this.amortizacaoAntecipadaService.ocorrencias;
        });
        
      }

    private ajustaCasasDecimais(valor: number): number {
        if (valor == undefined) {
            return undefined;
        }
        return Number((Math.round(valor * 100) / 100).toFixed(2));
    }

}
